import { render, staticRenderFns } from "./DatabaseServiceAccount.vue?vue&type=template&id=17d0c535"
import script from "./DatabaseServiceAccount.vue?vue&type=script&lang=js"
export * from "./DatabaseServiceAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports